const translations = {
  "en": {
    "Bank-Level": "Bank-Level",
    "Close": "Close",
    "Connect your accounts": "Connect your accounts",
    "Continue": "Continue",
    "Ed'll read it to find money you're leaving on the table, watch it against your goal, and flag anything worth acting on. Read-only, always.": "Ed'll read it to find money you're leaving on the table, watch it against your goal, and flag anything worth acting on. Read-only, always.",
    "Encryption": "Encryption",
    "never shared": "never shared",
    "Over 12,000 institutions supported": "Over 12,000 institutions supported",
    "Read-only,": "Read-only,"
  },
  "zh-tw": {
    "Bank-Level": "銀行級",
    "Close": "關閉",
    "Connect your accounts": "連結你的帳號",
    "Continue": "繼續",
    "Ed'll read it to find money you're leaving on the table, watch it against your goal, and flag anything worth acting on. Read-only, always.": "Ed 會為你讀取，找出你錯過的錢、對照你的目標檢視，並標出值得行動的項目。全程唯讀。",
    "Encryption": "加密",
    "never shared": "絕不外流",
    "Over 12,000 institutions supported": "支援超過 12,000 家機構",
    "Read-only,": "唯讀，"
  }
};

export default translations;
